/* src/app/features/modalidade-scr/habilitacao-scr/habilitacao-scr.component.scss */
.width-80 {
  width: 80%;
}
.width-95 {
  width: 95%;
}
.ng-dropdown-panel .ng-dropdown-panel-items .ng-option.ng-option-disabled {
  cursor: default;
}
/*# sourceMappingURL=habilitacao-scr.component.css.map */
